

module.exports = __webpack_require__.stylable.create(
    "scheduleitem1070570560",
    {"classes":{"root":"scheduleitem1070570560__root","modalContent":"scheduleitem1070570560__modalContent","container":"scheduleitem1070570560__container"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    10,
    "scheduleitem1070570560",
    null
);
